var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.5V15.5H45L30 0.5ZM33.75 30.5H11.25V38H33.75V30.5ZM26.25 15.5V0.5H5.625C2.46094 0.5 0 3.07812 0 6.125V54.875C0 58.0391 2.46094 60.5 5.625 60.5H39.375C42.4219 60.5 45 58.0391 45 54.875V19.25H30C27.8906 19.25 26.25 17.6094 26.25 15.5ZM7.5 8.9375C7.5 8.46875 7.85156 8 8.4375 8H17.8125C18.2812 8 18.75 8.46875 18.75 8.9375V10.8125C18.75 11.3984 18.2812 11.75 17.8125 11.75H8.4375C7.85156 11.75 7.5 11.3984 7.5 10.8125V8.9375ZM7.5 16.4375C7.5 15.9688 7.85156 15.5 8.4375 15.5H17.8125C18.2812 15.5 18.75 15.9688 18.75 16.4375V18.3125C18.75 18.8984 18.2812 19.25 17.8125 19.25H8.4375C7.85156 19.25 7.5 18.8984 7.5 18.3125V16.4375ZM37.5 52.0625C37.5 52.6484 37.0312 53 36.5625 53H27.1875C26.6016 53 26.25 52.6484 26.25 52.0625V50.1875C26.25 49.7188 26.6016 49.25 27.1875 49.25H36.5625C37.0312 49.25 37.5 49.7188 37.5 50.1875V52.0625ZM37.5 28.625V39.875C37.5 40.9297 36.5625 41.75 35.625 41.75H9.375C8.32031 41.75 7.5 40.9297 7.5 39.875V28.625C7.5 27.6875 8.32031 26.75 9.375 26.75H35.625C36.5625 26.75 37.5 27.6875 37.5 28.625Z",
    fill: "#FFB703"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryViews);
export default __webpack_public_path__ + "static/media/Summary-Views.2f70e5fdfe28e7f95da9b4c512069ddc.svg";
export { ForwardRef as ReactComponent };